import jwtDecode from "jwt-decode";
import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import ReactLoading from "react-loading";
import ErrorHandler from "../../../../common/ErrorHandler";
import { errorToast, successToast } from "../../../../react-toastfiy/toast";
import useLOSApplicationId from "../hooks/useLOSApplicationId";
import taService from "../services/ta.service";

const AddCommentModal = (props) => {
  const { onHide, modal, setModal, data } = props;

  const currentUser = localStorage.getItem("refreshToken");
  const user = jwtDecode(currentUser);
  const [formData, setFormData] = useState({ noteText: "" });
  const [commentData, setCommentData] = useState([]);
  const [loading, setLoading] = useState([]);
  const { setButtonLoader, buttonLoader, handleChange } = useLOSApplicationId({
    id: data?.taOnboardingCaseId,
    losApplicationId: data?.losApplicationId,
  });

  const handleSubmitComment = async (e) => {
    try {
      e.preventDefault();
      setButtonLoader(true);
      const form_data = new FormData();
      form_data.append("taOnboardingCaseId", data?.taOnboardingCaseId);
      form_data.append("noteText", formData?.noteText);

      const response = await taService.AddComment(form_data);
      if (response.status === 200) {
        setButtonLoader(false);
        successToast(response.msg);
        const now = new Date();

        const day = String(now.getDate()).padStart(2, "0");
        const month = String(now.getMonth() + 1).padStart(2, "0");
        const year = now.getFullYear();
        const date = `${day}-${month}-${year}`;

        const time = now.toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        });
        const newComment = {
          date: date,
          note: formData?.noteText,
          taOnboardingCaseId: data?.taOnboardingCaseId,
          time: time,
          user: user?.name,
        };
        setCommentData([...commentData, newComment]);
        setFormData({ noteText: "" });
      } else {
        setButtonLoader(false);
        errorToast(response.msg);
      }
    } catch (error) {
      console.error(error);
      errorToast(error?.message);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const form_data = new FormData();
        form_data.append("taOnboardingCaseId", data?.taOnboardingCaseId);

        const response = await taService.GetComment(form_data);
        if (response.status === 200) {
          setLoading(false);
          successToast(response.msg);
          setCommentData(response?.data);
        } else {
          setLoading(false);
          errorToast(response.msg);
        }
      } catch (error) {}
    };

    fetchData();
  }, []);

  try {
    return (
      <Modal
        {...props}
        size="lg"
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <div>
            {data?.businessType === "individual" ||
            data?.businessType === "Individual" ? (
              <h5>{`${data?.personName}`}</h5>
            ) : (
              <h5>{`${data?.personName} (${data?.companyName})`}</h5>
            )}
          </div>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              position: "sticky",
              top: 0,
              zIndex: 5,
              backgroundColor: "white",
              padding: "0.5rem",
            }}
          >
            <div
              style={{
                minHeight: "5rem",
                maxHeight: "15rem",
                overflowY: "auto",
              }}
            >
              {loading ? (
                <div className="d-flex justify-content-center">
                  <ReactLoading
                    type={"bubbles"}
                    color={"black"}
                    height={100}
                    width={100}
                  />
                </div>
              ) : (
                !loading &&
                Object.entries(commentData).length > 0 &&
                Object.entries(commentData).map(([keyBy, value], index) => (
                  <>
                    <div style={{ fontSize: "10px" }}>
                      {value?.date} | {value?.time}
                    </div>
                    <div
                      key={keyBy}
                      className="shadow-sm ps-3 pe-3 pb-3 mb-2 border"
                      style={{ borderRadius: "7px" }}
                    >
                      <div className="col-12">
                        <div className="col-12 text-bold">
                          <strong style={{ fontSize: "12px" }}>
                            {value?.user || " "}
                          </strong>
                        </div>
                        <div className="col-12 text-bold">
                          {value?.note || "N/A"}
                        </div>
                      </div>
                    </div>
                  </>
                ))
              )}
              {!loading && Object.entries(commentData).length === 0 && (
                <div
                  className="d-flex justify-content-center align-items-center text-danger"
                  style={{ marginTop: "2rem" }}
                >
                  <h4>No comments yet!</h4>
                </div>
              )}
            </div>
          </div>

          {!loading && user?.role === "Business Analyst" && (
            <div className="row mb-2">
              {/* <div className="col">
                <input
                  type="textArea"
                  className="form-control"
                  name="noteText"
                  value={formData.noteText}
                  placeholder="Enter comment..."
                  onChange={(e) => {
                    setFormData((prev) => ({
                      ...prev,
                      ["noteText"]: e.target.value,
                    }));
                  }}
                  style={{ height: "100px" }}
                />
              </div> */}

              <div className="col">
                <textarea
                  className="form-control"
                  name="noteText"
                  value={formData.noteText}
                  placeholder="Enter comment..."
                  onChange={(e) => {
                    setFormData((prev) => ({
                      ...prev,
                      noteText: e.target.value,
                    }));
                  }}
                  style={{ height: "90px", resize: "none" }}
                />
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Close
          </Button>
          <div className="d-flex justify-content-end">
            {buttonLoader ? (
              <button
                className="btn btn-primary"
                type="button"
                disabled
                id="loadingBtnTp"
              >
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                Loading...
              </button>
            ) : (
              user?.role === "Business Analyst" && (
                <Button onClick={handleSubmitComment}>Submit</Button>
              )
            )}
          </div>
        </Modal.Footer>
      </Modal>
    );
  } catch (error) {
    return <ErrorHandler error={error} />;
  }
};

export default AddCommentModal;
